import { Trans } from '@lingui/macro';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  TextField,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { enterpriseService, queryClient } from 'services';
import { useQuery, useMutation } from 'react-query';
import { TableEmpty } from 'components';
import { DateTime } from 'luxon';
import { useState } from 'react';

const EnterprisePaymentScheduleNote = ({ date }: { date: string }) => {
  const { data } = useQuery(
    ['enterpriseService.fetchPaymentScheduleNote', { date }],
    () => enterpriseService.fetchPaymentScheduleNote({ date }),
    { keepPreviousData: true },
  );

  const [content, setContent] = useState('');

  const { mutate: savePaymentScheduleNote, isLoading } = useMutation(enterpriseService.savePaymentScheduleNote, {
    onSuccess: () => {
      queryClient.invalidateQueries('enterpriseService.fetchPaymentScheduleNote');
      setContent('');
    },
  });

  const { data: items = [] } = data ?? {};

  const handleClickSubmit = () => {
    savePaymentScheduleNote({ content, date });
  };

  return (
    <>
      <div>
        <Typography variant='h4' className='bg-primary-light text-white text-center py-2'>
          <Trans>Note</Trans>
        </Typography>
        <TextField fullWidth className='my-2' value={content} onChange={(e) => setContent(e.target.value)} />
        <div className='flex justify-end w-full'>
          <LoadingButton variant='contained' onClick={handleClickSubmit} loading={isLoading}>
            <Trans>Save</Trans>
          </LoadingButton>
        </div>
      </div>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Trans>Date</Trans>
              </TableCell>
              <TableCell>
                <Trans>Executor</Trans>
              </TableCell>
              <TableCell>
                <Trans>Content</Trans>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => (
              <TableRow key={item.id}>
                <TableCell>{DateTime.fromISO(item.createdAt).toFormat('dd/MM/yyyy')}</TableCell>
                <TableCell>{item.createdUser}</TableCell>
                <TableCell>{item.content}</TableCell>
              </TableRow>
            ))}
            <TableEmpty data={items} />
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default EnterprisePaymentScheduleNote;
